import { Facebook, Instagram, Linkedin } from "lucide-react";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const ICONS = { instagram: Instagram, facebook: Facebook, tiktok: TikTokIcon, linkedin: Linkedin };

const PLATFORMS = [
  ["instagram", "Instagram"],
  ["facebook", "Facebook"],
  ["tiktok", "TikTok"],
  ["linkedin", "LinkedIn"],
];

export default function Socials({ site, variant = "dark" }) {
  const socials = PLATFORMS.map(([key, name]) => ({ key, name, url: site?.[key] })).filter((s) => s.url);
  if (socials.length === 0) return null;

  const cls =
    variant === "red"
      ? "border-white/40 text-white hover:bg-white hover:text-accent"
      : "border-white/15 text-white/60 hover:border-accent hover:text-accent";

  return (
    <div className="flex flex-wrap gap-2" data-testid="social-links">
      {socials.map((s) => {
        const Icon = ICONS[s.key];
        return (
          <a
            key={s.key}
            href={s.url.startsWith("http") ? s.url : `https://${s.url}`}
            target="_blank"
            rel="noreferrer"
            aria-label={`Strovyn on ${s.name}`}
            data-testid={`social-${s.key}`}
            className={`flex items-center gap-2 border px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors ${cls}`}
          >
            <Icon className="h-3.5 w-3.5" /> {s.name}
          </a>
        );
      })}
    </div>
  );
}
